import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)({
  position: 'relative',
  width: '100%',
});

export const ChipContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  alignItems: 'center',

  '& .MuiChip-root': {
    marginRight: 5,
    marginBottom: 2.5,
    marginTop: 2.5,

    '& .MuiIcon-root': {
      fontSize: '1.2rem',
    },
  },
});

export const InlineModal = styled('div')({
  '& .MuiIconButton-root': {
    borderRadius: 4,

    '& .MuiIcon-root': {
      fontSize: 16,
      width: 'auto',
      height: 'auto',
    },
  },
});

export const TradeMarker = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isIOS',
})(({ isIOS }) => ({
  position: 'absolute',
  top: isIOS ? -170 : -40,
  left: 0,
}));

export const Hidden = styled('div')({
  display: 'none',
});
